import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=571cf8a3&scoped=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"
import style0 from "./ThankYouPage.vue?vue&type=style&index=0&id=571cf8a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571cf8a3",
  null
  
)

export default component.exports